import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

// bito에는 생산관리가 없어 KSM의 "영업 캘린더/제조 스케줄러" 탭 중 영업 캘린더만 들어왔다가,
// 기술지원 일정도 합쳐져 "일정 관리"로 이름이 바뀌었다(2026-10-20).
// 탭이 하나뿐이면 탭 UI 자체가 의미 없어서(2026-10-20 결정) 탭 스트립 없이 바로 내용만 보여준다.
const ScheduleMngPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="공통관리/일정 관리" icon="schedule" />
      <Box sx={{ px: 2, pb: 3 }}>
        <Outlet />
      </Box>
    </>
  );
};

export default ScheduleMngPage;
